import styled from "styled-components";
import Column from "../Column/Column";
import Row from "../Row/Row";
import Text from "../Text/Text";
import invest_in_music from "./imgs/invest_in_music.png";
import license_music_info from "./imgs/license_music_info.png";
import create_nft_info from "./imgs/musicnote.png";

export const HowItWorksRow = styled(Column)`
  justify-content: flex-start;
  margin-top: 5%;
  justify-content: center;
  align-items: center;
`;

const HowItWorksInfo = styled.div`
  background: rgba(196, 196, 196, 0.1);
  backdrop-filter: blur(61.9333px);
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding-inline: 1%;
  text-align: center;
  flex: 1;
  min-height: 35vh;
  max-height: 35vh;

  @media screen and (max-width: 650px) {
    padding-bottom: 30px;
    background: none;
    min-width: 100%;
  }

  @media screen and (min-height: 1200px) {
    min-height: 20vh;
    max-height: 20vh;
  }
`;

const HeaderText = styled.h2`
  color: ${(props) => props.theme.body};
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
  line-height: 35.7px;
`;

const HowItWorksInfoContainer = styled(Row)`
  gap: 5%;
  align-items: flex-start;
  flex-wrap: wrap;
`;

const DescriptionText = styled(Text)`
  @media screen and (max-width: 650px) {
    padding-inline: 5%;
  }
`;

const HowItWorks = () => {
  return (
    <HowItWorksInfoContainer>
      <HowItWorksInfo>
        <HeaderText>Music NFTs</HeaderText>
        <img src={create_nft_info} />
        <DescriptionText>
          Tokenize your music and sell ownership and royalties to fans,
          creators, and producers.
        </DescriptionText>
      </HowItWorksInfo>

      <HowItWorksInfo>
        <HeaderText>License Music</HeaderText>
        <img src={license_music_info} />
        <DescriptionText>
          Issue licenses to creators to utilize your music in their content.
        </DescriptionText>
      </HowItWorksInfo>
      <HowItWorksInfo>
        <HeaderText>Invest in Music</HeaderText>
        <img src={invest_in_music} />
        <DescriptionText>
          Invest in artists through NFTS, as the artists grows, everybody wins.
        </DescriptionText>
      </HowItWorksInfo>
    </HowItWorksInfoContainer>
  );
};

export default HowItWorks;
